<template>
  <div class="card">
    <div class="card-campaign">
      <div class="card-campaign-content">
        <p class="mt-13"><Skeleton width="100%" height="85px" /></p>
        <p class="mt-13"><Skeleton width="100%" height="85px" /></p>
        <p class="mt-13 mb-20"><Skeleton width="100%" height="85px" /></p>
      </div>
    </div>
    <div class="card-slider mr-20 mt-13">
      <Skeleton height="190px" width="100%" />
      <div class="mt-10 mb-20 d-flex justify-between">
        <Skeleton height="17px" width="30%" />
        <Skeleton height="17px" width="30%" />
      </div>
      <Hr />
      <div class="mt-20 d-flex justify-between">
        <Skeleton width="24px" height="24px" borderRadius="10px" />
        <Skeleton height="17px" width="30%" />
        <Skeleton width="24px" height="24px" borderRadius="10px" />
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from '@/components/Skeleton/Skeleton';
import { Hr } from '@n11/so-ui-components';

export default {
  name: 'CampaignSkeleton',
  components: {
    Skeleton,
    Hr,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/utilities.scss';

.card-campaign {
  width: 50%;
  margin: 0 20px;
}
.card-slider {
  width: 50%;
}
</style>
